/* Generated from Java with JSweet 2.3.7 - http://www.jsweet.org */
import { JsonCompat } from '../../../compat/JsonCompat';
import { Constants } from '../../../core/Constants';
import { Document } from '../../../core/models/Document';
import { AuthorizationCodeOAuthFlow } from '../../../core/models/common/AuthorizationCodeOAuthFlow';
import { ClientCredentialsOAuthFlow } from '../../../core/models/common/ClientCredentialsOAuthFlow';
import { Components } from '../../../core/models/common/Components';
import { IDefinition } from '../../../core/models/common/IDefinition';
import { IExample } from '../../../core/models/common/IExample';
import { ImplicitOAuthFlow } from '../../../core/models/common/ImplicitOAuthFlow';
import { OAuthFlow } from '../../../core/models/common/OAuthFlow';
import { OAuthFlows } from '../../../core/models/common/OAuthFlows';
import { Operation } from '../../../core/models/common/Operation';
import { Parameter } from '../../../core/models/common/Parameter';
import { PasswordOAuthFlow } from '../../../core/models/common/PasswordOAuthFlow';
import { Schema } from '../../../core/models/common/Schema';
import { SecurityScheme } from '../../../core/models/common/SecurityScheme';
import { Server } from '../../../core/models/common/Server';
import { ServerVariable } from '../../../core/models/common/ServerVariable';
import { OasDataModelWriter } from '../../io/OasDataModelWriter';
import { OasHeader } from '../../models/OasHeader';
import { OasPathItem } from '../../models/OasPathItem';
import { OasResponse } from '../../models/OasResponse';
import { Oas30Callback } from '../models/Oas30Callback';
import { Oas30CallbackDefinition } from '../models/Oas30CallbackDefinition';
import { Oas30CallbackPathItem } from '../models/Oas30CallbackPathItem';
import { Oas30Discriminator } from '../models/Oas30Discriminator';
import { Oas30Document } from '../models/Oas30Document';
import { Oas30Encoding } from '../models/Oas30Encoding';
import { Oas30Example } from '../models/Oas30Example';
import { Oas30ExampleDefinition } from '../models/Oas30ExampleDefinition';
import { Oas30Header } from '../models/Oas30Header';
import { Oas30HeaderDefinition } from '../models/Oas30HeaderDefinition';
import { Oas30Link } from '../models/Oas30Link';
import { Oas30LinkDefinition } from '../models/Oas30LinkDefinition';
import { Oas30LinkParameterExpression } from '../models/Oas30LinkParameterExpression';
import { Oas30LinkRequestBodyExpression } from '../models/Oas30LinkRequestBodyExpression';
import { Oas30LinkServer } from '../models/Oas30LinkServer';
import { Oas30MediaType } from '../models/Oas30MediaType';
import { Oas30Parameter } from '../models/Oas30Parameter';
import { Oas30PathItem } from '../models/Oas30PathItem';
import { Oas30RequestBody } from '../models/Oas30RequestBody';
import { Oas30RequestBodyDefinition } from '../models/Oas30RequestBodyDefinition';
import { Oas30Response } from '../models/Oas30Response';
import { Oas30Schema } from '../models/Oas30Schema';
import { Oas30SecurityScheme } from '../models/Oas30SecurityScheme';
import { IOas30Visitor } from '../visitors/IOas30Visitor';

/**
 * @author eric.wittmann@gmail.com
 * @class
 * @extends OasDataModelWriter
 */
export class Oas30DataModelWriter extends OasDataModelWriter implements IOas30Visitor {
    /**
     * @see io.apicurio.datamodels.core.io.DataModelWriter#writeDocument(io.apicurio.datamodels.core.models.Document, java.lang.Object)
     * @param {Document} node
     * @param {*} json
     */
    writeDocument(node : Document, json : any) {
        let doc : Oas30Document = <Oas30Document>node;
        JsonCompat.setPropertyString(json, Constants.PROP_OPENAPI, doc.openapi);
        JsonCompat.setPropertyNull(json, Constants.PROP_INFO);
        JsonCompat.setPropertyNull(json, Constants.PROP_SERVERS);
        JsonCompat.setPropertyNull(json, Constants.PROP_PATHS);
        JsonCompat.setPropertyNull(json, Constants.PROP_COMPONENTS);
        JsonCompat.setPropertyNull(json, Constants.PROP_SECURITY);
        JsonCompat.setPropertyNull(json, Constants.PROP_TAGS);
        JsonCompat.setPropertyNull(json, Constants.PROP_EXTERNAL_DOCS);
        this.writeExtraProperties(json, node);
    }

    /**
     * @see io.apicurio.datamodels.openapi.io.OasDataModelWriter#writeHeader(java.lang.Object, io.apicurio.datamodels.openapi.models.OasHeader)
     * @param {*} json
     * @param {OasHeader} node
     */
    writeHeader(json : any, node : OasHeader) {
        let header : Oas30Header = <Oas30Header>node;
        JsonCompat.setPropertyString(json, Constants.PROP_$REF, header.$ref);
        JsonCompat.setPropertyBoolean(json, Constants.PROP_REQUIRED, header.required);
        JsonCompat.setPropertyBoolean(json, Constants.PROP_DEPRECATED, header.deprecated);
        JsonCompat.setPropertyBoolean(json, Constants.PROP_ALLOW_EMPTY_VALUE, header.allowEmptyValue);
        JsonCompat.setPropertyString(json, Constants.PROP_STYLE, header.style);
        JsonCompat.setPropertyBoolean(json, Constants.PROP_EXPLODE, header.explode);
        JsonCompat.setPropertyBoolean(json, Constants.PROP_ALLOW_RESERVED, header.allowReserved);
        JsonCompat.setPropertyNull(json, Constants.PROP_SCHEMA);
        JsonCompat.setProperty(json, Constants.PROP_EXAMPLE, header.example);
        JsonCompat.setPropertyNull(json, Constants.PROP_EXAMPLES);
        JsonCompat.setPropertyNull(json, Constants.PROP_CONTENT);
        super.writeHeader(json, node);
    }

    /**
     * @see io.apicurio.datamodels.openapi.io.OasDataModelWriter#addHeaderToParent(java.lang.Object, java.lang.Object, io.apicurio.datamodels.openapi.models.OasHeader)
     * @param {*} parent
     * @param {*} json
     * @param {OasHeader} node
     */
    addHeaderToParent(parent : any, json : any, node : OasHeader) {
        let headers : any = JsonCompat.getProperty(parent, Constants.PROP_HEADERS);
        if(headers == null) {
            headers = JsonCompat.objectNode();
            JsonCompat.setProperty(parent, Constants.PROP_HEADERS, headers);
        }
        JsonCompat.setProperty(headers, node.getName(), json);
    }

    /**
     * @see io.apicurio.datamodels.openapi.io.OasDataModelWriter#writeOperation(java.lang.Object, io.apicurio.datamodels.core.models.common.Operation)
     * @param {*} json
     * @param {Operation} node
     */
    writeOperation(json : any, node : Operation) {
        JsonCompat.setPropertyNull(json, Constants.PROP_REQUEST_BODY);
        JsonCompat.setPropertyNull(json, Constants.PROP_CALLBACKS);
        JsonCompat.setPropertyNull(json, Constants.PROP_SERVERS);
        super.writeOperation(json, node);
    }

    /**
     * @see io.apicurio.datamodels.openapi.io.OasDataModelWriter#writePathItem(java.lang.Object, io.apicurio.datamodels.openapi.models.OasPathItem)
     * @param {*} json
     * @param {OasPathItem} node
     */
    writePathItem(json : any, node : OasPathItem) {
        let pathItem : Oas30PathItem = <Oas30PathItem>node;
        JsonCompat.setPropertyString(json, Constants.PROP_SUMMARY, pathItem.summary);
        JsonCompat.setPropertyString(json, Constants.PROP_DESCRIPTION, pathItem.description);
        JsonCompat.setPropertyNull(json, Constants.PROP_TRACE);
        JsonCompat.setPropertyNull(json, Constants.PROP_SERVERS);
        super.writePathItem(json, node);
    }

    /**
     * @see io.apicurio.datamodels.openapi.io.OasDataModelWriter#writeParameter(java.lang.Object, io.apicurio.datamodels.core.models.common.Parameter)
     * @param {*} json
     * @param {Parameter} node
     */
    writeParameter(json : any, node : Parameter) {
        let parameter : Oas30Parameter = <Oas30Parameter>node;
        JsonCompat.setPropertyBoolean(json, Constants.PROP_DEPRECATED, parameter.deprecated);
        JsonCompat.setPropertyString(json, Constants.PROP_STYLE, parameter.style);
        JsonCompat.setPropertyBoolean(json, Constants.PROP_EXPLODE, parameter.explode);
        JsonCompat.setPropertyBoolean(json, Constants.PROP_ALLOW_RESERVED, parameter.allowReserved);
        JsonCompat.setProperty(json, Constants.PROP_EXAMPLE, parameter.example);
        JsonCompat.setPropertyNull(json, Constants.PROP_EXAMPLES);
        JsonCompat.setPropertyNull(json, Constants.PROP_CONTENT);
        super.writeParameter(json, node);
    }

    /**
     * @see io.apicurio.datamodels.openapi.io.OasDataModelWriter#writeResponse(java.lang.Object, io.apicurio.datamodels.openapi.models.OasResponse)
     * @param {*} json
     * @param {OasResponse} node
     */
    writeResponse(json : any, node : OasResponse) {
        let response : Oas30Response = <Oas30Response>node;
        JsonCompat.setPropertyNull(json, Constants.PROP_HEADERS);
        JsonCompat.setPropertyNull(json, Constants.PROP_CONTENT);
        JsonCompat.setPropertyNull(json, Constants.PROP_LINKS);
        super.writeResponse(json, response);
    }

    /**
     * @see io.apicurio.datamodels.openapi.io.OasDataModelWriter#writeSchema(java.lang.Object, io.apicurio.datamodels.core.models.common.Schema)
     * @param {*} json
     * @param {Schema} node
     */
    writeSchema(json : any, node : Schema) {
        let schema : Oas30Schema = <Oas30Schema>node;
        JsonCompat.setPropertyNull(json, Constants.PROP_ONE_OF);
        JsonCompat.setPropertyNull(json, Constants.PROP_ANY_OF);
        JsonCompat.setPropertyNull(json, Constants.PROP_NOT);
        JsonCompat.setPropertyNull(json, Constants.PROP_DISCRIMINATOR);
        JsonCompat.setPropertyBoolean(json, Constants.PROP_NULLABLE, schema.nullable);
        JsonCompat.setPropertyBoolean(json, Constants.PROP_WRITE_ONLY, schema.writeOnly);
        JsonCompat.setPropertyBoolean(json, Constants.PROP_DEPRECATED, schema.deprecated);
        super.writeSchema(json, node);
    }

    /**
     * @see io.apicurio.datamodels.core.io.DataModelWriter#writeSecurityScheme(java.lang.Object, io.apicurio.datamodels.core.models.common.SecurityScheme)
     * @param {*} json
     * @param {SecurityScheme} node
     */
    writeSecurityScheme(json : any, node : SecurityScheme) {
        let schema : Oas30SecurityScheme = <Oas30SecurityScheme>node;
        JsonCompat.setPropertyString(json, Constants.PROP_$REF, schema.$ref);
        JsonCompat.setPropertyString(json, Constants.PROP_SCHEME, schema.scheme);
        JsonCompat.setPropertyString(json, Constants.PROP_BEARER_FORMAT, schema.bearerFormat);
        JsonCompat.setPropertyNull(json, Constants.PROP_FLOWS);
        JsonCompat.setPropertyString(json, Constants.PROP_OPEN_ID_CONNECT_URL, schema.openIdConnectUrl);
        super.writeSecurityScheme(json, node);
    }

    /**
     * @see io.apicurio.datamodels.core.io.DataModelWriter#addParameterDefinitionToParent(java.lang.Object, java.lang.Object, io.apicurio.datamodels.core.models.common.IDefinition)
     * @param {*} parent
     * @param {*} json
     * @param {*} node
     */
    addParameterDefinitionToParent(parent : any, json : any, node : IDefinition) {
        let parameters : any = JsonCompat.getProperty(parent, Constants.PROP_PARAMETERS);
        if(parameters == null) {
            parameters = JsonCompat.objectNode();
            JsonCompat.setProperty(parent, Constants.PROP_PARAMETERS, parameters);
        }
        JsonCompat.setProperty(parameters, node.getName(), json);
    }

    /**
     * @see io.apicurio.datamodels.openapi.v3.visitors.IOas30Visitor#visitComponents(io.apicurio.datamodels.core.models.common.Components)
     * @param {Components} node
     */
    public visitComponents(node : Components) {
        let parent : any = this.lookupParentJson$io_apicurio_datamodels_core_models_Node(node);
        let json : any = JsonCompat.objectNode();
        this.writeExtraProperties(json, node);
        JsonCompat.setProperty(parent, Constants.PROP_COMPONENTS, json);
        this.updateIndex(node, json);
    }

    /**
     * @see io.apicurio.datamodels.openapi.v3.visitors.IOas30Visitor#visitCallbackPathItem(io.apicurio.datamodels.openapi.v3.models.Oas30CallbackPathItem)
     * @param {Oas30CallbackPathItem} node
     */
    public visitCallbackPathItem(node : Oas30CallbackPathItem) {
        this.visitPathItem(node);
    }

    /**
     * @see io.apicurio.datamodels.openapi.v3.visitors.IOas30Visitor#visitCallback(io.apicurio.datamodels.openapi.v3.models.Oas30Callback)
     * @param {Oas30Callback} node
     */
    public visitCallback(node : Oas30Callback) {
        let parent : any = this.lookupParentJson$io_apicurio_datamodels_core_models_Node(node);
        let json : any = JsonCompat.objectNode();
        this.writeCallback(json, node);
        this.writeExtraProperties(json, node);
        let callbacks : any = JsonCompat.getProperty(parent, Constants.PROP_CALLBACKS);
        if(callbacks == null) {
            callbacks = JsonCompat.objectNode();
            JsonCompat.setProperty(parent, Constants.PROP_CALLBACKS, callbacks);
        }
        JsonCompat.setProperty(callbacks, node.getName(), json);
        this.updateIndex(node, json);
    }

    writeCallback(json : any, node : Oas30Callback) {
        JsonCompat.setPropertyString(json, Constants.PROP_$REF, node.$ref);
    }

    /**
     * @see io.apicurio.datamodels.openapi.v3.visitors.IOas30Visitor#visitLinkServer(io.apicurio.datamodels.openapi.v3.models.Oas30LinkServer)
     * @param {Oas30LinkServer} node
     */
    public visitLinkServer(node : Oas30LinkServer) {
        let parent : any = this.lookupParentJson$io_apicurio_datamodels_core_models_Node(node);
        let json : any = JsonCompat.objectNode();
        JsonCompat.setPropertyString(json, Constants.PROP_URL, node.url);
        JsonCompat.setPropertyString(json, Constants.PROP_DESCRIPTION, node.description);
        JsonCompat.setPropertyNull(json, Constants.PROP_VARIABLES);
        this.writeExtraProperties(json, node);
        JsonCompat.setProperty(parent, Constants.PROP_SERVER, json);
        this.updateIndex(node, json);
    }

    /**
     * @see io.apicurio.datamodels.openapi.v3.visitors.IOas30Visitor#visitCallbackDefinition(io.apicurio.datamodels.openapi.v3.models.Oas30CallbackDefinition)
     * @param {Oas30CallbackDefinition} node
     */
    public visitCallbackDefinition(node : Oas30CallbackDefinition) {
        this.visitCallback(node);
    }

    /**
     * @see io.apicurio.datamodels.openapi.v3.visitors.IOas30Visitor#visitLink(io.apicurio.datamodels.openapi.v3.models.Oas30Link)
     * @param {Oas30Link} node
     */
    public visitLink(node : Oas30Link) {
        let parent : any = this.lookupParentJson$io_apicurio_datamodels_core_models_Node(node);
        let json : any = JsonCompat.objectNode();
        JsonCompat.setPropertyString(json, Constants.PROP_$REF, node.$ref);
        JsonCompat.setPropertyString(json, Constants.PROP_OPERATION_REF, node.operationRef);
        JsonCompat.setPropertyString(json, Constants.PROP_OPERATION_ID, node.operationId);
        JsonCompat.setPropertyNull(json, Constants.PROP_PARAMETERS);
        JsonCompat.setPropertyNull(json, Constants.PROP_REQUEST_BODY);
        JsonCompat.setPropertyString(json, Constants.PROP_DESCRIPTION, node.description);
        JsonCompat.setPropertyNull(json, Constants.PROP_SERVER);
        this.writeExtraProperties(json, node);
        let links : any = JsonCompat.getProperty(parent, Constants.PROP_LINKS);
        if(links == null) {
            links = JsonCompat.objectNode();
            JsonCompat.setProperty(parent, Constants.PROP_LINKS, links);
        }
        JsonCompat.setProperty(links, node.getName(), json);
        this.updateIndex(node, json);
    }

    /**
     * @see io.apicurio.datamodels.openapi.v3.visitors.IOas30Visitor#visitLinkRequestBodyExpression(io.apicurio.datamodels.openapi.v3.models.Oas30LinkRequestBodyExpression)
     * @param {Oas30LinkRequestBodyExpression} node
     */
    public visitLinkRequestBodyExpression(node : Oas30LinkRequestBodyExpression) {
        let parent : any = this.lookupParentJson$io_apicurio_datamodels_core_models_Node(node);
        JsonCompat.setPropertyString(parent, Constants.PROP_REQUEST_BODY, node.getValue());
    }

    /**
     * @see io.apicurio.datamodels.openapi.v3.visitors.IOas30Visitor#visitLinkParameterExpression(io.apicurio.datamodels.openapi.v3.models.Oas30LinkParameterExpression)
     * @param {Oas30LinkParameterExpression} node
     */
    public visitLinkParameterExpression(node : Oas30LinkParameterExpression) {
        let parent : any = this.lookupParentJson$io_apicurio_datamodels_core_models_Node(node);
        let parameters : any = JsonCompat.getProperty(parent, Constants.PROP_PARAMETERS);
        if(parameters == null) {
            parameters = JsonCompat.objectNode();
            JsonCompat.setProperty(parent, Constants.PROP_PARAMETERS, parameters);
        }
        JsonCompat.setPropertyString(parameters, node.getName(), node.getValue());
    }

    /**
     * @see io.apicurio.datamodels.openapi.v3.visitors.IOas30Visitor#visitLinkDefinition(io.apicurio.datamodels.openapi.v3.models.Oas30LinkDefinition)
     * @param {Oas30LinkDefinition} node
     */
    public visitLinkDefinition(node : Oas30LinkDefinition) {
        this.visitLink(node);
    }

    /**
     * @see io.apicurio.datamodels.openapi.v3.visitors.IOas30Visitor#visitAuthorizationCodeOAuthFlow(io.apicurio.datamodels.core.models.common.AuthorizationCodeOAuthFlow)
     * @param {AuthorizationCodeOAuthFlow} node
     */
    public visitAuthorizationCodeOAuthFlow(node : AuthorizationCodeOAuthFlow) {
        this.doVisitOAuthFlow(node, Constants.PROP_AUTHORIZATION_CODE);
    }

    /**
     * @see io.apicurio.datamodels.openapi.v3.visitors.IOas30Visitor#visitClientCredentialsOAuthFlow(io.apicurio.datamodels.core.models.common.ClientCredentialsOAuthFlow)
     * @param {ClientCredentialsOAuthFlow} node
     */
    public visitClientCredentialsOAuthFlow(node : ClientCredentialsOAuthFlow) {
        this.doVisitOAuthFlow(node, Constants.PROP_CLIENT_CREDENTIALS);
    }

    /**
     * @see io.apicurio.datamodels.openapi.v3.visitors.IOas30Visitor#visitPasswordOAuthFlow(io.apicurio.datamodels.core.models.common.PasswordOAuthFlow)
     * @param {PasswordOAuthFlow} node
     */
    public visitPasswordOAuthFlow(node : PasswordOAuthFlow) {
        this.doVisitOAuthFlow(node, Constants.PROP_PASSWORD);
    }

    /**
     * @see io.apicurio.datamodels.openapi.v3.visitors.IOas30Visitor#visitImplicitOAuthFlow(io.apicurio.datamodels.core.models.common.ImplicitOAuthFlow)
     * @param {ImplicitOAuthFlow} node
     */
    public visitImplicitOAuthFlow(node : ImplicitOAuthFlow) {
        this.doVisitOAuthFlow(node, Constants.PROP_IMPLICIT);
    }

    /**
     * Visit an OAuth flow.
     * @param {OAuthFlow} node
     * @param {string} flowName
     */
    doVisitOAuthFlow(node : OAuthFlow, flowName : string) {
        let parent : any = this.lookupParentJson$io_apicurio_datamodels_core_models_Node(node);
        let json : any = JsonCompat.objectNode();
        JsonCompat.setPropertyString(json, Constants.PROP_AUTHORIZATION_URL, node.authorizationUrl);
        JsonCompat.setPropertyString(json, Constants.PROP_TOKEN_URL, node.tokenUrl);
        JsonCompat.setPropertyString(json, Constants.PROP_REFRESH_URL, node.refreshUrl);
        JsonCompat.setProperty(json, Constants.PROP_SCOPES, node.scopes);
        this.writeExtraProperties(json, node);
        JsonCompat.setProperty(parent, flowName, json);
        this.updateIndex(node, json);
    }

    /**
     * @see io.apicurio.datamodels.openapi.v3.visitors.IOas30Visitor#visitOAuthFlows(io.apicurio.datamodels.core.models.common.OAuthFlows)
     * @param {OAuthFlows} node
     */
    public visitOAuthFlows(node : OAuthFlows) {
        let parent : any = this.lookupParentJson$io_apicurio_datamodels_core_models_Node(node);
        let json : any = JsonCompat.objectNode();
        JsonCompat.setPropertyNull(json, Constants.PROP_IMPLICIT);
        JsonCompat.setPropertyNull(json, Constants.PROP_PASSWORD);
        JsonCompat.setPropertyNull(json, Constants.PROP_CLIENT_CREDENTIALS);
        JsonCompat.setPropertyNull(json, Constants.PROP_AUTHORIZATION_CODE);
        this.writeExtraProperties(json, node);
        JsonCompat.setProperty(parent, Constants.PROP_FLOWS, json);
        this.updateIndex(node, json);
    }

    /**
     * @see io.apicurio.datamodels.openapi.visitors.IOasVisitor#visitExample(io.apicurio.datamodels.core.models.common.IExample)
     * @param {*} node
     */
    public visitExample(node : IExample) {
        let example30 : Oas30Example = <Oas30Example><any>node;
        let parent : any = this.lookupParentJson$io_apicurio_datamodels_core_models_Node(example30);
        let json : any = JsonCompat.objectNode();
        JsonCompat.setPropertyString(json, Constants.PROP_$REF, example30.$ref);
        JsonCompat.setPropertyString(json, Constants.PROP_SUMMARY, example30.summary);
        JsonCompat.setPropertyString(json, Constants.PROP_DESCRIPTION, example30.description);
        JsonCompat.setProperty(json, Constants.PROP_VALUE, example30.value);
        JsonCompat.setPropertyString(json, Constants.PROP_EXTERNAL_VALUE, example30.externalValue);
        this.writeExtraProperties(json, example30);
        let examples : any = JsonCompat.getProperty(parent, Constants.PROP_EXAMPLES);
        if(examples == null) {
            examples = JsonCompat.objectNode();
            JsonCompat.setProperty(parent, Constants.PROP_EXAMPLES, examples);
        }
        JsonCompat.setProperty(examples, example30.getName(), json);
        this.updateIndex(example30, json);
    }

    /**
     * @see io.apicurio.datamodels.openapi.v3.visitors.IOas30Visitor#visitEncoding(io.apicurio.datamodels.openapi.v3.models.Oas30Encoding)
     * @param {Oas30Encoding} node
     */
    public visitEncoding(node : Oas30Encoding) {
        let parent : any = this.lookupParentJson$io_apicurio_datamodels_core_models_Node(node);
        let json : any = JsonCompat.objectNode();
        JsonCompat.setPropertyString(json, Constants.PROP_CONTENT_TYPE, node.contentType);
        JsonCompat.setPropertyNull(json, Constants.PROP_HEADERS);
        JsonCompat.setPropertyString(json, Constants.PROP_STYLE, node.style);
        JsonCompat.setPropertyBoolean(json, Constants.PROP_EXPLODE, node.explode);
        JsonCompat.setPropertyBoolean(json, Constants.PROP_ALLOW_RESERVED, node.allowReserved);
        this.writeExtraProperties(json, node);
        let encoding : any = JsonCompat.getProperty(parent, Constants.PROP_ENCODING);
        if(encoding == null) {
            encoding = JsonCompat.objectNode();
            JsonCompat.setProperty(parent, Constants.PROP_ENCODING, encoding);
        }
        JsonCompat.setProperty(encoding, node.getName(), json);
        this.updateIndex(node, json);
    }

    /**
     * @see io.apicurio.datamodels.openapi.v3.visitors.IOas30Visitor#visitMediaType(io.apicurio.datamodels.openapi.v3.models.Oas30MediaType)
     * @param {Oas30MediaType} node
     */
    public visitMediaType(node : Oas30MediaType) {
        let parent : any = this.lookupParentJson$io_apicurio_datamodels_core_models_Node(node);
        let json : any = JsonCompat.objectNode();
        JsonCompat.setPropertyNull(json, Constants.PROP_SCHEMA);
        JsonCompat.setProperty(json, Constants.PROP_EXAMPLE, node.example);
        JsonCompat.setPropertyNull(json, Constants.PROP_EXAMPLES);
        JsonCompat.setPropertyNull(json, Constants.PROP_ENCODING);
        this.writeExtraProperties(json, node);
        let content : any = JsonCompat.getProperty(parent, Constants.PROP_CONTENT);
        if(content == null) {
            content = JsonCompat.objectNode();
            JsonCompat.setProperty(parent, Constants.PROP_CONTENT, content);
        }
        JsonCompat.setProperty(content, node.getName(), json);
        this.updateIndex(node, json);
    }

    /**
     * @see io.apicurio.datamodels.openapi.v3.visitors.IOas30Visitor#visitHeaderDefinition(io.apicurio.datamodels.openapi.v3.models.Oas30HeaderDefinition)
     * @param {Oas30HeaderDefinition} node
     */
    public visitHeaderDefinition(node : Oas30HeaderDefinition) {
        let parent : any = this.lookupParentJson$io_apicurio_datamodels_core_models_Node(node);
        let json : any = JsonCompat.objectNode();
        this.writeHeader(json, node);
        this.writeExtraProperties(json, node);
        let headers : any = JsonCompat.getProperty(parent, Constants.PROP_HEADERS);
        if(headers == null) {
            headers = JsonCompat.objectNode();
            JsonCompat.setProperty(parent, Constants.PROP_HEADERS, headers);
        }
        JsonCompat.setProperty(headers, node.getName(), json);
        this.updateIndex(node, json);
    }

    /**
     * @see io.apicurio.datamodels.openapi.v3.visitors.IOas30Visitor#visitRequestBody(io.apicurio.datamodels.openapi.v3.models.Oas30RequestBody)
     * @param {Oas30RequestBody} node
     */
    public visitRequestBody(node : Oas30RequestBody) {
        let parent : any = this.lookupParentJson$io_apicurio_datamodels_core_models_Node(node);
        let json : any = JsonCompat.objectNode();
        this.writeRequestBody(json, node);
        this.writeExtraProperties(json, node);
        JsonCompat.setProperty(parent, Constants.PROP_REQUEST_BODY, json);
        this.updateIndex(node, json);
    }

    /**
     * @see io.apicurio.datamodels.openapi.v3.visitors.IOas30Visitor#visitRequestBodyDefinition(io.apicurio.datamodels.openapi.v3.models.Oas30RequestBodyDefinition)
     * @param {Oas30RequestBodyDefinition} node
     */
    public visitRequestBodyDefinition(node : Oas30RequestBodyDefinition) {
        let parent : any = this.lookupParentJson$io_apicurio_datamodels_core_models_Node(node);
        let json : any = JsonCompat.objectNode();
        this.writeRequestBody(json, node);
        this.writeExtraProperties(json, node);
        let requestBodies : any = JsonCompat.getProperty(parent, Constants.PROP_REQUEST_BODIES);
        if(requestBodies == null) {
            requestBodies = JsonCompat.objectNode();
            JsonCompat.setProperty(parent, Constants.PROP_REQUEST_BODIES, requestBodies);
        }
        JsonCompat.setProperty(requestBodies, node.getName(), json);
        this.updateIndex(node, json);
    }

    writeRequestBody(json : any, node : Oas30RequestBody) {
        JsonCompat.setPropertyString(json, Constants.PROP_$REF, node.$ref);
        JsonCompat.setPropertyString(json, Constants.PROP_DESCRIPTION, node.description);
        JsonCompat.setPropertyNull(json, Constants.PROP_CONTENT);
        JsonCompat.setPropertyBoolean(json, Constants.PROP_REQUIRED, node.required);
    }

    /**
     * @see io.apicurio.datamodels.openapi.v3.visitors.IOas30Visitor#visitExampleDefinition(io.apicurio.datamodels.openapi.v3.models.Oas30ExampleDefinition)
     * @param {Oas30ExampleDefinition} node
     */
    public visitExampleDefinition(node : Oas30ExampleDefinition) {
        this.visitExample(node);
    }

    /**
     * @see io.apicurio.datamodels.openapi.v3.visitors.IOas30Visitor#visitDiscriminator(io.apicurio.datamodels.openapi.v3.models.Oas30Discriminator)
     * @param {Oas30Discriminator} node
     */
    public visitDiscriminator(node : Oas30Discriminator) {
        let parent : any = this.lookupParentJson$io_apicurio_datamodels_core_models_Node(node);
        let json : any = JsonCompat.objectNode();
        JsonCompat.setPropertyString(json, Constants.PROP_PROPERTY_NAME, node.propertyName);
        JsonCompat.setProperty(json, Constants.PROP_MAPPING, node.mapping);
        this.writeExtraProperties(json, node);
        JsonCompat.setProperty(parent, Constants.PROP_DISCRIMINATOR, json);
        this.updateIndex(node, json);
    }

    /**
     * @see io.apicurio.datamodels.openapi.v3.visitors.IOas30Visitor#visitNotSchema(io.apicurio.datamodels.openapi.v3.models.Oas30Schema.Oas30NotSchema)
     * @param {Oas30Schema.Oas30NotSchema} node
     */
    public visitNotSchema(node : Oas30Schema.Oas30NotSchema) {
        this.doVisitSchema(node, Constants.PROP_NOT, false);
    }

    /**
     * @see io.apicurio.datamodels.openapi.v3.visitors.IOas30Visitor#visitOneOfSchema(io.apicurio.datamodels.openapi.v3.models.Oas30Schema.Oas30OneOfSchema)
     * @param {Oas30Schema.Oas30OneOfSchema} node
     */
    public visitOneOfSchema(node : Oas30Schema.Oas30OneOfSchema) {
        this.doVisitSchema(node, Constants.PROP_ONE_OF, true);
    }

    /**
     * @see io.apicurio.datamodels.openapi.v3.visitors.IOas30Visitor#visitAnyOfSchema(io.apicurio.datamodels.openapi.v3.models.Oas30Schema.Oas30AnyOfSchema)
     * @param {Oas30Schema.Oas30AnyOfSchema} node
     */
    public visitAnyOfSchema(node : Oas30Schema.Oas30AnyOfSchema) {
        this.doVisitSchema(node, Constants.PROP_ANY_OF, true);
    }

    /**
     * @see io.apicurio.datamodels.core.io.DataModelWriter#addSchemaDefinitionToParent(java.lang.Object, java.lang.Object, io.apicurio.datamodels.core.models.common.IDefinition)
     * @param {*} parent
     * @param {*} json
     * @param {*} node
     */
    addSchemaDefinitionToParent(parent : any, json : any, node : IDefinition) {
        let schemas : any = JsonCompat.getProperty(parent, Constants.PROP_SCHEMAS);
        if(schemas == null) {
            schemas = JsonCompat.objectNode();
            JsonCompat.setProperty(parent, Constants.PROP_SCHEMAS, schemas);
        }
        JsonCompat.setProperty(schemas, node.getName(), json);
    }

    /**
     * @see io.apicurio.datamodels.openapi.io.OasDataModelWriter#addResponseDefinitionToParent(java.lang.Object, java.lang.Object, io.apicurio.datamodels.core.models.common.IDefinition)
     * @param {*} parent
     * @param {*} json
     * @param {*} node
     */
    addResponseDefinitionToParent(parent : any, json : any, node : IDefinition) {
        let responses : any = JsonCompat.getProperty(parent, Constants.PROP_RESPONSES);
        if(responses == null) {
            responses = JsonCompat.objectNode();
            JsonCompat.setProperty(parent, Constants.PROP_RESPONSES, responses);
        }
        JsonCompat.setProperty(responses, node.getName(), json);
    }

    /**
     * @see io.apicurio.datamodels.core.io.DataModelWriter#addSecuritySchemeToParent(java.lang.Object, java.lang.Object, io.apicurio.datamodels.core.models.common.SecurityScheme)
     * @param {*} parent
     * @param {*} json
     * @param {SecurityScheme} node
     */
    addSecuritySchemeToParent(parent : any, json : any, node : SecurityScheme) {
        let securitySchemes : any = JsonCompat.getProperty(parent, Constants.PROP_SECURITY_SCHEMES);
        if(securitySchemes == null) {
            securitySchemes = JsonCompat.objectNode();
            JsonCompat.setProperty(parent, Constants.PROP_SECURITY_SCHEMES, securitySchemes);
        }
        JsonCompat.setProperty(securitySchemes, node.getSchemeName(), json);
    }

    /**
     * @see io.apicurio.datamodels.openapi.v3.visitors.IOas30Visitor#visitServer(io.apicurio.datamodels.core.models.common.Server)
     * @param {Server} node
     */
    public visitServer(node : Server) {
        let parent : any = this.lookupParentJson$io_apicurio_datamodels_core_models_Node(node);
        let json : any = JsonCompat.objectNode();
        this.writeServer(json, node);
        this.writeExtraProperties(json, node);
        JsonCompat.appendToArrayProperty(parent, Constants.PROP_SERVERS, json);
        this.updateIndex(node, json);
    }

    writeServer(json : any, node : Server) {
        JsonCompat.setPropertyString(json, Constants.PROP_URL, node.url);
        JsonCompat.setPropertyString(json, Constants.PROP_DESCRIPTION, node.description);
        JsonCompat.setPropertyNull(json, Constants.PROP_VARIABLES);
    }

    /**
     * @see io.apicurio.datamodels.openapi.v3.visitors.IOas30Visitor#visitServerVariable(io.apicurio.datamodels.core.models.common.ServerVariable)
     * @param {ServerVariable} node
     */
    public visitServerVariable(node : ServerVariable) {
        let parent : any = this.lookupParentJson$io_apicurio_datamodels_core_models_Node(node);
        let json : any = JsonCompat.objectNode();
        this.writeServerVariable(json, node);
        this.writeExtraProperties(json, node);
        let variables : any = JsonCompat.getProperty(parent, Constants.PROP_VARIABLES);
        if(variables == null) {
            variables = JsonCompat.objectNode();
            JsonCompat.setProperty(parent, Constants.PROP_VARIABLES, variables);
        }
        JsonCompat.setProperty(variables, node.getName(), json);
        this.updateIndex(node, json);
    }

    writeServerVariable(json : any, node : ServerVariable) {
        JsonCompat.setPropertyStringArray(json, Constants.PROP_ENUM, node.enum_);
        JsonCompat.setPropertyString(json, Constants.PROP_DEFAULT, node.default_);
        JsonCompat.setPropertyString(json, Constants.PROP_DESCRIPTION, node.description);
        JsonCompat.setPropertyNull(json, Constants.PROP_VARIABLES);
    }

    constructor() {
        super();
    }
}
Oas30DataModelWriter["__class"] = "io.apicurio.datamodels.openapi.v3.io.Oas30DataModelWriter";
Oas30DataModelWriter["__interfaces"] = ["io.apicurio.datamodels.core.visitors.IVisitor","io.apicurio.datamodels.openapi.v3.visitors.IOas30Visitor","io.apicurio.datamodels.openapi.visitors.IOasVisitor"];




